import { getCalcParams, FLEX_SHARES, FULLY_DEPRECIATED_RESIDUAL } from './calcParams.js'

const LENDING_TERM_NUMBERS = [4, 5, 6, 7]

export const FLEX_KEYS = Object.freeze(['low', 'medium', 'high'])

export function pmt(rate, nper, pv, fv = 0) {
    if (rate === 0) return (pv + fv) / nper
    const xp = Math.pow(1 + rate, nper)
    const f = rate / (xp - 1)
    return f * (pv * xp + fv)
}

function readPositive(n) {
    return typeof n === 'number' && Number.isFinite(n) && n > 0 ? n : null
}

function readResidual(data) {
    if (data && data.depreciation) return FULLY_DEPRECIATED_RESIDUAL
    const pos = readPositive(data ? data.residual : null)
    return pos == null ? 0 : pos
}

function monthlyRate(annualRate) {
    return Math.pow(1 + annualRate, 1 / 12) - 1
}

export function calculateOffer(data) {
    if (!data) return null

    const amount = readPositive(data.amount)
    const yearsCandidate = Number(data.lending)
    const years = Number.isFinite(yearsCandidate) && LENDING_TERM_NUMBERS.includes(yearsCandidate)
        ? yearsCandidate
        : null
    const utilization = readPositive(data.utilization)

    if (amount === null || years === null || utilization === null) return null

    const params = getCalcParams()
    const fv = readResidual(data)
    const months = years * 12
    const r = monthlyRate(params.annualRefinancingRate)
    const fullMonthly = Math.abs(pmt(r, months, -amount, fv))
    const monthlyUtil = utilization / 12

    const monthlyBaseFee = {}
    const perUsage = {}
    for (const key of FLEX_KEYS) {
        const flex = FLEX_SHARES[key]
        monthlyBaseFee[key] = fullMonthly * (1 - flex)
        perUsage[key] = (fullMonthly * flex) / (monthlyUtil * params.breakEven)
    }
    return { monthlyBaseFee, perUsage }
}
